import { Component, Injector, OnInit } from '@angular/core';

import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../../common/BaseComponent';


@Component({
  selector: 'app-no-services',
  templateUrl: './no-services.component.html',
  styles: [
  ]
})
export class NoServicesComponent extends BaseComponent implements OnInit {

  constructor(
    injector: Injector,
    public rest: UserService
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  viewProfile() : void {
    this.router.navigate(['secure/profile']);
  }

}
